/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_End_Time_SecondsInputs */

const en_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Time (Seconds)`)
};

const fr_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure de fin (secondes)`)
};

const de_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endzeit (Sekunden)`)
};

const it_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo finale (secondi)`)
};

const ru_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время окончания (в секундах)`)
};

const es_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de finalización (segundos)`)
};

const zh_cn2_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束时间（秒）`)
};

const ja_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了時間（秒）`)
};

const hi_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति समय (सेकंड)`)
};

const pt_pt2_markers_export_end_time_seconds = /** @type {(inputs: Markers_Export_End_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo final (em segundos)`)
};

/**
* | output |
* | --- |
* | "End Time (Seconds)" |
*
* @param {Markers_Export_End_Time_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_end_time_seconds = /** @type {((inputs?: Markers_Export_End_Time_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_End_Time_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_export_end_time_seconds(inputs)
	if (locale === "de") return de_markers_export_end_time_seconds(inputs)
	if (locale === "it") return it_markers_export_end_time_seconds(inputs)
	if (locale === "ru") return ru_markers_export_end_time_seconds(inputs)
	if (locale === "es") return es_markers_export_end_time_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_export_end_time_seconds(inputs)
	if (locale === "ja") return ja_markers_export_end_time_seconds(inputs)
	if (locale === "hi") return hi_markers_export_end_time_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_export_end_time_seconds(inputs)
	return en_markers_export_end_time_seconds(inputs)
});